import * as React from "react";
import * as _ from "lodash";

interface SwitchProps {
    show: boolean;
    children?: React.ReactChildren;
}

export class Condition extends React.Component<SwitchProps, {}> {

    render() {
        if (this.props.show === true) {
            return <span>{this.props.children}</span>
        } else {
            return <span/>
        }

    }
}



// WEBPACK FOOTER //
// ./src/app/ui/form/Condition.tsx